import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/api';
import { SelectItem } from "primeng/components/common/selectitem";
import { CreateCampaignModel } from "../../../models/inModels/campaign";
import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { CampaignService } from "../../../services/campaign.service";
import { StorageService } from "../../../services/system/storage.service";

@Component({
	selector: 'app-campaigns-create',
	templateUrl: './campaigns-create.component.html',
	styleUrls: ['./campaigns-create.component.css']
})
export class CampaignsCreateComponent implements OnInit {
	model: CreateCampaignModel;
	loading = false;
	error: Message[];
	messages: Message[];
	locations: SelectItem[];
	selectedLocation: SelectItem;
	types: SelectItem[];
	selectedType: SelectItem;
	constructor(
		private storageService: StorageService,
		private auth: AuthenticationService,
		private router: Router,
		private service: CampaignService) {
		this.model = new CreateCampaignModel();
	}

	ngOnInit() {
	}

	initDropDown(event) {
		this.service.getDropdown(event).then(
			x => {
				this.locations = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setLocation(): void {
		this.model.Url = this.selectedLocation.value;
	}

	goBack(): void {
		this.router.navigate(['/campaigns']);
	}

	save() {
		this.loading = true;
		this.service.create(this.model).then(
			result => {
				this.loading = false;
				this.router.navigate(['/campaigns/edit', result.Id]);
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	initDropDownTypes(event) {
		this.service.getDropdownTypes(event).then(
			x => {
				this.types = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setType(): void {
		this.model.PersistType = this.selectedType.value;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/campaigns/campaigns-create/campaigns-create.component.ts